import {hashCodeCertificate} from "./hoc/hashCodeCertificate";

const WaybillV2ResponsiblePersonAccept = hashCodeCertificate("WaybillV2ResponsiblePersonAccept")

export default WaybillV2ResponsiblePersonAccept
